import { useCallback, useEffect, useState } from 'react';
import client from '../../../shared/api/client';
import { toastError } from '../../../shared/toastHelper';

export const SUPPORT_REQUESTS_PATH = '/conductor/venue_chat/support_requests.json';

export function useSupportRequests() {
  const [supportRequests, setSupportRequests] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let ignore = false;
    setLoading(true);
    setError(false);
    client.get(SUPPORT_REQUESTS_PATH)
      .then((response) => {
        if (!ignore) setSupportRequests(response.data.support_requests);
      })
      .catch(() => {
        if (ignore) return;
        setError(true);
        toastError("Couldn't load your support requests. Try again.");
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [attempt]);

  const reload = useCallback(() => setAttempt((count) => count + 1), []);

  return { supportRequests, loading, error, reload };
}
